// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Vatican City */
const VA = /^(?:3[1-9]\d{8}|3[2-9]\d{7})$/;

export default VA;
